module.exports = __webpack_public_path__ + "img/duplicate-performance.888b7aea.svg";